/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuthStore } from '../../features/auth/store';
import { getOspreyApiBaseUrl } from './apiBase';

// IAM/Watchman calls go through osprey-api's iam-proxy (<base>/iam/*), which
// forwards /iam/<rest> -> internal watchman /api/v1/<rest>. The Osprey UI never
// calls watchman directly — single origin (osprey-api). See apiBase.ts.
const getWatchmanBaseUrl = (): string => getOspreyApiBaseUrl() + '/iam';

async function watchmanRequest<T = any>(
  method: string,
  endpoint: string,
  data?: any,
): Promise<T> {
  const baseUrl = getWatchmanBaseUrl();
  const headers: HeadersInit = { Accept: 'application/json' };
  if (data !== undefined && method !== 'GET') headers['Content-Type'] = 'application/json';

  const token = useAuthStore.getState().token;
  if (token) headers['Authorization'] = 'Bearer ' + token;

  const config: RequestInit = { method, headers };
  if (data !== undefined && method !== 'GET') config.body = JSON.stringify(data);

  const res = await fetch(baseUrl + endpoint, config);

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    if (res.status === 401) {
      const { logout } = useAuthStore.getState();
      logout();
      if (typeof window !== 'undefined') {
        const currentPath = window.location.pathname + window.location.search;
        window.location.href = "/login?redirect_to=" + encodeURIComponent(currentPath);
      }
    }
    const rawMsg = err.message;
    const message = Array.isArray(rawMsg)
      ? (rawMsg[0] || res.statusText || 'Validation error')
      : (rawMsg || err.errors?.[0]?.message || res.statusText || 'Something went wrong');
    throw { status: res.status, message, errors: err.errors, fullError: err };
  }

  return res.json();
}

export const WatchmanFetch = {
  get: <T = any>(endpoint: string) => watchmanRequest<T>('GET', endpoint),
  post: <T = any>(endpoint: string, data?: any) => watchmanRequest<T>('POST', endpoint, data),
  patch: <T = any>(endpoint: string, data?: any) => watchmanRequest<T>('PATCH', endpoint, data),
  del: <T = any>(endpoint: string) => watchmanRequest<T>('DELETE', endpoint),
};
